import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpEvent, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {HttpHandler} from '@angular/common/http/src/backend';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';
import {UserService} from "./services/user.service";

@Injectable()
export class CustomInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    // private notifierService: NotifierService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = UserService.getToken();
    if (token) {
      req = req.clone({
        setHeaders: {
          'Authorization': 'Bearer ' + token
        },
      });
    }

    return next.handle(req).pipe(
      tap(response => {
        if (response instanceof HttpResponse) {
          if (!response.body) {
            // this.notifierService.notify('warning', "Empty Response Received");
          }
          switch (response.status) {
            case 200:
            case 201:
              break;
            case 0:
              // this.notifierService.notify('error', 'Something went wrong.');
              // console.warn('danger', 'Error, Please check logs.');
              break;
            default:
              // this.notifierService.notify('error', 'Something went wrong.');
              // console.warn('danger', JSON.parse(response.body).msg);
          }
        }
      }, response => {
        switch (response.status) {
          case 500:
            // this.notifierService.notify('error', 'An internal server error occurred');
            break;
          case 403:
            // this.notifierService.notify('error', 'You are not allowed to perform this action! Forbidden.');
            break;
          case 401:
            // this.notifierService.notify('error', 'You are not allowed to perform this action! Unauthorized.');
            break;
          case 400:
          case 422:
            // const message = 'message' in response.error ? response.error.message : response.error;
            // this.notifierService.notify('error', message);
            break;
          case 0:
            // this.notifierService.notify('error', 'Something went wrong.');
            // console.warn('danger', 'Error, Please check logs.');
            break;
          default:
            // this.notifierService.notify('error', 'Something went wrong.');
            // console.warn('danger', response);
        }
      })
    );
  }
}
